import { Action } from '@ngrx/store';

export enum CustomerActions {
    GetAllCustomers = '[customer] Get All customer',
    GetAllCustomerSuccess = '[customer] Set All Customer Success',
    GetAllCustomerError = '[customer] Set All Customer Error',
    AddCustomer = '[customer] Add Customer',
    GetAddCustomerSuccess = '[customer] Get Add Customer Success',
    GetAddCustomerError = '[customer] Get Add Customer Error',
    ImportCustomerExcel = '[customer] Import Customer Excel',
    ImportCustomerExcelSuccess = '[customer] Import Customer Excel Success',
    ImportCustomerExcelError = '[customer] Import Customer Excel Error',
    EditCustomer = '[customer] Edit Customer',
    GetEditCustomerSuccess = '[customer] Edit Customer Success',
    GetEditCustomerError = '[customer] Edit Customer Error',
    GetCustomerNum = '[customer] Get Customer Number',
    GetCustomerNumberSuccess = '[customer] Get Customer Number success',
    GetCustomerNumberError = '[customer] Get Customer Number Error',
    DeleteCustomer = '[Customer] Delete Customer',
    SetDeleteCustomerSuccess = '[Customer] Set Delete Customer Success',
    SetDeleteCustomerError = '[Customer] Set Delete Customer Error',
    CustomerContactReview = '[Customer] Customer ContactReview',
    SetCustomerContactReviewSuccess = '[Customer] Set ContactReview Customer Success',
    SetCustomerContactReviewError = '[Customer] Set ContactReview Customer Error',

}

export class GetAllCustomers implements Action {
    public readonly type = CustomerActions.GetAllCustomers;
    constructor(public payload: any) {

    }
}

export class GetAllCustomerSuccess implements Action {
    public readonly type = CustomerActions.GetAllCustomerSuccess;
    constructor(public payload: any) {
    }
}
export class GetAllCustomerError implements Action {
    public readonly type = CustomerActions.GetAllCustomerError;
    constructor(public payload: any) {
    }
}
export class ImportCustomerExcel implements Action {
    public readonly type = CustomerActions.ImportCustomerExcel;
    constructor(public payload: any) {

    }
}
export class ImportCustomerExcelSuccess implements Action {
    public readonly type = CustomerActions.ImportCustomerExcelSuccess;
    constructor(public payload: any) {

    }
}
export class ImportCustomerExcelError implements Action {
    public readonly type = CustomerActions.ImportCustomerExcelError;
    constructor(public payload: any) {

    }
}
export class AddCustomer implements Action {
    public readonly type = CustomerActions.AddCustomer;
    constructor(public payload: any) {

    }
}
export class GetAddCustomerSuccess implements Action {
    public readonly type = CustomerActions.GetAddCustomerSuccess;
    constructor(public payload: any) {

    }
}
export class GetAddCustomerError implements Action {
    public readonly type = CustomerActions.GetAddCustomerError;
    constructor(public payload: any) {

    }
}
export class EditCustomer implements Action {
    public readonly type = CustomerActions.EditCustomer;
    constructor(public payload: any) { }
}
export class GetEditCustomerSuccess implements Action {
    public readonly type = CustomerActions.GetEditCustomerSuccess;
    constructor(public payload: any) { }
}
export class GetEditCustomerError implements Action {
    public readonly type = CustomerActions.GetEditCustomerError;
    constructor(public payload: any) { }
}

export class GetCustomerNum implements Action {
    public readonly type = CustomerActions.GetCustomerNum;
    constructor(public payload: any) { }
}
export class GetCustomerNumberSuccess implements Action {
    public readonly type = CustomerActions.GetCustomerNumberSuccess;
    constructor(public payload: any) {

    }
}
export class GetCustomerNumberError implements Action {
    public readonly type = CustomerActions.GetCustomerNumberError;
    constructor(public payload: any) { }
}

export class DeleteCustomer implements Action {
    public readonly type = CustomerActions.DeleteCustomer;
    constructor(public payload: any, public param: any) { }
}

export class SetDeleteCustomerSuccess implements Action {
    public readonly type = CustomerActions.SetDeleteCustomerSuccess;
    constructor(public payload: any) { }
}

export class SetDeleteCustomerError implements Action {
    public readonly type = CustomerActions.SetDeleteCustomerError;
    constructor(public payload: any) { }
}

export class CustomerContactReview implements Action {
    public readonly type = CustomerActions.CustomerContactReview;
    constructor(public payload: any, public param: any) { }
}

export class SetCustomerContactReviewSuccess implements Action {
    public readonly type = CustomerActions.SetCustomerContactReviewSuccess;
    constructor(public payload: any) { }
}

export class SetCustomerContactReviewError implements Action {
    public readonly type = CustomerActions.SetCustomerContactReviewError;
    constructor(public payload: any) { }
}

export type CustomerAction = GetAllCustomers | GetAllCustomerSuccess | GetAllCustomerError | AddCustomer |
    GetAddCustomerSuccess | GetAddCustomerError | EditCustomer | GetEditCustomerSuccess |
    GetEditCustomerError | GetCustomerNum | GetCustomerNumberSuccess | GetCustomerNumberError | DeleteCustomer |
    SetDeleteCustomerSuccess | SetDeleteCustomerError | CustomerContactReview | SetCustomerContactReviewSuccess |
    SetCustomerContactReviewError|ImportCustomerExcel|ImportCustomerExcelSuccess|ImportCustomerExcelError;



